<section role="dialog" aria-modal="true" aria-labelledby="add-user-title" class="sm:w-[51.2rem] w-[70vw] sm:h-[50.8rem] max-sm:min-h-[50vh] flex flex-col items-center justify-center overflow-hidden ">
    <button type="button" class="absolute w-fit top-[4rem] right-[4rem] cursor-pointer" (click)="closePopup()" aria-label="Close add user">
        <dsr-icon name="cancel" size="1.6rem" color="black" aria-hidden="true"></dsr-icon>
    </button>
    <div class=" w-full !p-[6rem] ">
        <div class="flex flex-col items-center justify-center ">
            <h2 mat-dialog-title id="add-user-title">{{'ORGUSER_CREATE_USER_TEXT' | translate}}</h2>
            <span class="dsr-typescale-body-small-prominent">*{{'FORM_MANDATORY_TEXT' | translate}}</span>
        </div>

        <form [formGroup]="addUserForm" class="w-full mt-10">
            <fieldset class="w-full ">
                <legend class="sr-only">Add new user</legend>
                <mat-dialog-content class="!max-h-none !w-full !p-0">
                    <div class="w-full flex flex-col gap-[2rem] pt-2">
                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>{{'FORM_FIRSTNAME_LABEL' | translate}}</mat-label>
                            <input matInput formControlName="firstName" id="{{'FORM_FIRSTNAME_LABEL' | translate}}"
                                type="text" autocomplete="given-name" required aria-required="true" />
                            @if(addUserForm.get('firstName')?.invalid && addUserForm.get('firstName')?.touched) {
                            <mat-error>{{getErrorMessage('firstName')}}</mat-error>
                            }
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>{{'FORM_LASTNAME_LABEL' | translate}}</mat-label>
                            <input matInput formControlName="lastName" id="{{'FORM_LASTNAME_LABEL' | translate}}"
                                type="text" autocomplete="family-name" required aria-required="true" />
                            @if(addUserForm.get('lastName')?.invalid && addUserForm.get('lastName')?.touched) {
                            <mat-error>{{getErrorMessage('lastName')}}</mat-error>
                            }
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="w-full">
                            <mat-label>E-mail</mat-label>
                            <input matInput id="E-mail" type="email" formControlName="email"
                                [placeholder]="'FORM_EMAIL_PLACEHOLDER' | translate" autocomplete="email" required
                                aria-required="true" />
                            <dsr-icon name="mail" matSuffix aria-hidden="true"></dsr-icon>
                            @if(addUserForm.get('email')?.invalid && addUserForm.get('email')?.touched) {
                            <mat-error>{{getErrorMessage('email')}}</mat-error>
                            }
                        </mat-form-field>
                    </div>
                </mat-dialog-content>

                <mat-dialog-actions class="" role="group" aria-label="Add user actions">
                    <button type="submit" color="" mat-flat-button class="" (click)="addUser()" aria-label="Register new user" [disabled]="addUserForm.invalid">
                        <span class="!capitalize">{{'ORGADMIN_REGISTER' | translate}}</span>
                    </button>
                    <button type="button" mat-stroked-button class="" color="primary" (click)="closePopup()" aria-label="Cancel add user">
                        <span class="!capitalize">{{'CANCEL_BUTTON' | translate}}</span>
                    </button>
                </mat-dialog-actions>
            </fieldset>
        </form>
    </div>
</section>